<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelEmpresa"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :multiple="isMultiple"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="tag" slot-scope="{ option, remove }">
      <span class="badge badge-primary mr-1">
        <span class="text-truncate mr-1 mb-1">
          {{ `${option.nome}` }}
        </span>
        <span class="custom__remove badge" @mousedown.prevent.stop="remove(option)"> x </span>
      </span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'isMultiple'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_empresa', null);
        return;
      }

      if (this.isMultiple) {
        let arr = new Array();
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'id_empresa', arr);
      } else {
        this.$emit('selectChange', 'id_empresa', e.id);
      }
      this.$emit('selectChange', 'id_empresa', e.id);
    },
    labelEmpresa({ nome, numero }) {
      return numero ? `${numero} - ${nome}` : `${nome}`;
    },
    setValue(value) {
      if (this.isMultiple) {
        this.selected = new Array();
        if (value) {
          value.forEach((el) => {
            this.selected.push(this.options.find((option) => option.id === el));
          });
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
      } else {
        if (value) {
          this.selected = this.options.find((option) => option.id === value);
          this.reload ? this.$emit('selectChange', 'id_empresa', this.selected.id) : null;
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getEmpresas({
          columns: 'id,nome',
          order: 'nome'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    },
    reload: function (value) {
      this.setOptions(value);
    }
  },
  created() {
    this.setOptions();
  }
};
</script>

<style lang="scss" scoped></style>
